import api from '../api-methods'

const proxyApi = process.env.VUE_APP_ENV === 'local' ? '/proxy_api' : process.env.VUE_APP_API

const hackathon = {
	// 获取简历列表
	getQusList: payload => {
		return api.get(proxyApi + '/v3/interviews/questions/predict', payload)
	},
    
    //获取问题详情
    getQusDetail: payload => {
		return api.get(proxyApi + '/v3/interviews/questions/'+payload)
    },

    //获取我的列表
    getMyList:payload=>{
        return api.get(proxyApi + '/v3/interviews/questions',payload)
    },
    
    //获取历史消息
    getHistory:payload=>{
        return api.get(proxyApi + '/v3/interviews/questions/recent_result',payload)
    },

    //修改问题消息
    updateQus:payload=>{
        return api.put(proxyApi + '/v3/interviews/questions/'+payload.token,payload)
    },

    //评论列表
    getComment:payload=>{
        return api.get(proxyApi + '/v3/interviews/question_template_comments',payload)
    },

    //微信登录
    wxLogin:payload =>{
        return api.post(proxyApi + '/v3/auth/wechat_web_users/login_or_sign_up',payload)
    },

    //获取appid
    getAppId:payload => {
        return api.get(proxyApi + '/v3/get_wechat_config',payload)
    }

}

export default hackathon
